import { brandName } from './HeaderBase.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';

import { AriaRoles } from 'owa-accessibility';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { getHeaderImageData } from 'owa-theme';
import { HEADER_BUTTONS_REGION_ID } from 'owa-header';
import { observer } from 'mobx-react-lite';

const styles = require('./Header.scss');
const classNames = require('classnames');

export interface HeaderBaseViewProps {
    searchMode?: boolean;
    headerLeftSectionStyle?: React.CSSProperties;
    leftCharms?: JSX.Element[];
    rightCharms?: JSX.Element[];
    centeredSearchBox?: boolean; // Defaults to true; this allows modules to opt out.
    children?: React.ReactNode;
}

interface HeaderLogoProps {
    headerLeftSectionStyle?: React.CSSProperties;
}

const HeaderLogo = observer((props: HeaderLogoProps) => {
    return (
        <a href="" className={styles.logo} data-is-focusable="true">
            <span className={styles.logoText}>{loc(brandName)}</span>
        </a>
    );
});

const HeaderBase = observer(function HeaderBase(props: HeaderBaseViewProps) {
    let backgroundStyle: React.CSSProperties;
    const { searchMode, leftCharms, rightCharms, headerLeftSectionStyle, children } = props;

    const headerImageData = getHeaderImageData();

    // do not display theme image when search is active
    if (!searchMode && headerImageData.primary) {
        // Create the CSS value.
        let backgroundImageCss = `url(${headerImageData.primary})`;

        if (headerImageData.staticBg) {
            // GIF may have a static image to help preloading it quickly.
            backgroundImageCss += `,url(${headerImageData.staticBg})`;
        }

        backgroundStyle = {
            backgroundImage: backgroundImageCss,
            backgroundRepeat: headerImageData.repeat ? 'repeat-x' : 'no-repeat',
        };
    }

    // We place the background in its own div in the center so we can easily
    // flip it in RTL languages and we can make sure the Waffle on the left
    // stays on the left and the elements on the right stay on the right of the screen
    // when using the "space-between" css rule.
    return (
        <div className={classNames(styles.main, searchMode && styles.inSearch)}>
            <FocusZone
                style={headerLeftSectionStyle}
                className={styles.headerLeftSection}
                direction={FocusZoneDirection.horizontal}
                rootProps={{ role: AriaRoles.menubar }}>
                {leftCharms}
                <HeaderLogo />
            </FocusZone>
            <div className={styles.headerMiddleSection}>{children}</div>
            <div style={backgroundStyle} className={classNames(styles.background, 'flipForRtl')} />
            <FocusZone
                id={HEADER_BUTTONS_REGION_ID}
                direction={FocusZoneDirection.horizontal}
                className={styles.headerRightSection}
                rootProps={{ role: AriaRoles.menubar }}>
                {rightCharms}
            </FocusZone>
        </div>
    );
});
export default HeaderBase;
